import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CONTACT_CONFIG } from './contact.config';
import { MSocialMedia } from '../';

export default function MContactInfo() {
	return (
		<article className="m-contact m-contact--info">
			<p className="label m-contact--arrow">
				<FormattedMessage id="CONTACT_INFO.CONTACT_US" defaultMessage="" />
			</p>
			<address>
				<a href={`tel:${CONTACT_CONFIG.info.telephone}`}>
					<FormattedMessage id="CONTACT_INFO.PHONE" defaultMessage="" />
					{CONTACT_CONFIG.info.telephone}
				</a>
				<a href={`mailto:${CONTACT_CONFIG.info.email}`}>
					<FormattedMessage id="CONTACT_INFO.EMAIL" defaultMessage="" />
					{CONTACT_CONFIG.info.email}
				</a>
			</address>
			<div>
				<p>
					<FormattedMessage id="CONTACT_INFO.VISIT_OUR_SOCIAL_MEDIA" defaultMessage="" />
				</p>
				<MSocialMedia className="social-media" type="iconColor" />
			</div>
		</article>
	);
}




// WEBPACK FOOTER //
// ./src/components/molecules/contact/_molecules.contact-info.js